import { throttle } from "../../lib";
import DOMHelper from "../../lib/dom-helper";

export default class PinnedNavModule {
	constructor($root) {
		this.$root = $root;
		this.$siteHeaderNav = this.$root.querySelector('.site-header-nav');
		this.$siteHeaderNavMobile = this.$root.querySelector('.mobile-site-header-nav');
		this.$schoolHomepageHeroSectionLogo = document.querySelector('.section-content_logo')

		this.currentOffset = null;
		this.headerOffset = null;

		this.init();
	}

	init() {
		this.getOffset();
		this.toggle();
		this.addEventListeners();
	}

	addEventListeners() {
		window.addEventListener('scroll', throttle(() => {
			this.toggle();
		}, 20));
		window.addEventListener('resize', throttle(() => {
			this.getOffset();
		}, 20));
	}

	getOffset() {
		const mediaMatches = window.matchMedia('(max-width: 768px)').matches;

		if (document.body.classList.contains('-blog')) {
			if (mediaMatches) {
				this.headerOffset = DOMHelper.getElementTopPosition(this.$siteHeaderNavMobile);
			} else {
				this.headerOffset = DOMHelper.getElementTopPosition(this.$siteHeaderNav) + this.$siteHeaderNav.offsetHeight;
			}
			return;
		}

		const headerHeight = this.$root.offsetHeight;

		if (mediaMatches) {
			this.headerOffset = headerHeight;

			if (document.body.classList.contains('-school') && document.body.classList.contains('-homepage') && this.$schoolHomepageHeroSectionLogo) {
				this.headerOffset = this.$schoolHomepageHeroSectionLogo.getBoundingClientRect().top + window.scrollY + this.$schoolHomepageHeroSectionLogo.scrollHeight;
			}

			return;
		}

		const siteNavHeight = this.$siteHeaderNav.offsetHeight;

		this.headerOffset = headerHeight + siteNavHeight;
	}

	toggle() {
		this.currentOffset = window.scrollY;

		if (this.currentOffset > this.headerOffset) {
			this.show();
		} else {
			this.hide();
		}
	}

	show() {
		this.$root.classList.add('-pinned');
	}

	hide() {
		this.$root.classList.remove('-pinned');
	}
}